import { WeightUnitEnum } from "@/api/model";
import { getFormattedDate } from "@/shared/utils/helpers";
import Fraction from "fraction.js";

export const formatHeight = (
  totalInches: number | null | undefined
): string => {
  if (totalInches == null) return "";
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return `${feet}' ${inches}"`;
};

export const formatWeight = (
  weight: number | null | undefined,
  unit = WeightUnitEnum.lbs
): string => {
  if (weight == null) return "";
  return `${weight} ${unit}`;
};

export const formatDisplayDate = (
  date: Date | string | null | undefined
): string => {
  if (!date) return "";
  return getFormattedDate(date, "MMM dd, yyyy");
};

export const formatHatSizeNumbered = (
  value: number | null | undefined
): string => {
  if (value == null) return "";
  const fraction = new Fraction(value);
  return fraction.toFraction(true);
};

export const parsePlainDate = (
  dateString?: string | null
): Temporal.PlainDate | null => {
  if (!dateString) return null;
  try {
    return Temporal.PlainDate.from(dateString);
  } catch {
    return null;
  }
};

export const formatPlainDate = (
  date: Temporal.PlainDate | null | undefined
): string => {
  if (!date) return "";
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};
